import React from 'react';

import { Typography } from '@mui/material';
import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<StyleProps>()((theme, { withBorderBottom }) => ({
  header: {
    alignItems: 'center',
    borderBottom: withBorderBottom ? `1px ${theme.appColors.rule} solid` : undefined,
    boxSizing: 'border-box' as const,
    display: 'flex',
    flexShrink: 0,
    height: 48,
  },
  title: {
    alignContent: 'center',
    color: theme.appColors.iconsType,
    display: 'flex',
  },
}));

interface StyleProps {
  withBorderBottom: boolean;
}

interface ContentHeaderProps extends React.HTMLAttributes<HTMLElement> {
  title: string;
  withBorderBottom?: boolean;
}

export function ContentHeader({
  children,
  className,
  title,
  withBorderBottom = true,
}: ContentHeaderProps): JSX.Element {
  const { classes } = useStyles({ withBorderBottom });

  return (
    <header className={clsx(classes.header, className)}>
      <Typography className={classes.title} variant="h2">
        {title}
      </Typography>
      {children}
    </header>
  );
}

/**
 * Styles for subheaders that are used in the same way as ContentHeader
 * but with more content in the header.
 */
export const useSubheaderStyles = makeStyles()(theme => ({
  contentContainer: {
    alignItems: 'center',
    borderBottom: `1px solid ${theme.appColors.rule}`,
    boxSizing: 'border-box' as const,
    display: 'flex',
    flex: 1,
    height: 48,
    justifyContent: 'end',
  },
  root: {
    alignItems: 'center',
    display: 'flex',
  },
}));
